(function () {
	angular
		.module('trackeye')
		.controller('MessageEventIconController', MessageEventIconController);

	MessageEventIconController.$inject = ['$scope', '$translate', 'EventIconMeta'];

	function MessageEventIconController($scope, $translate, EventIconMeta) {
		var vm = this;

		vm.getEventTypeTitle = function(img) {
			title = $translate.instant(img.title);
			if (img.title_addition) {
				title += ", " +$translate.instant(img.title_addition);
			}

			return title;
		}

		vm.getPosTypeTitle = function () {
			var className = getPosTypeName($scope.message);

			return "STR_ACTIVE_EVENT_POS_" + className.replace("-", "_").toUpperCase();
		}

		vm.getPosTypeClass = function () {
			var className = getPosTypeName($scope.message);

			return "c4a-" + className;
		};

		function getPosTypeName (message) {
			className = "";

			if (message.isGSM() || message.isTriangulationActive()) {
				className = "gsm";
			} else if (message.isGPS()) {
				className = "gps";
			} else {
				className = "no-position";
			}

			return className;
		};

		vm.renderMetaData = function(message, nextMessage, device) {
			return EventIconMeta.getMeta(message, nextMessage, device);
		};
	}
})();